import React from 'react'
import Achievements from '../Components/Achievement'

function Achievement() {
  return (
    <>
    <Achievements />
    </>
  )
}

export default Achievement
